<template>
  <!-- 添加编辑 幻灯片 -->
  <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    label-width="90px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="标题" prop="title">
      <el-input
        clearable
        v-model="ruleForm.title"
        placeholder="请填写标题"
        class="middle_input"
      />
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item label="投放终端" prop="slideCategoryId">
          <el-select
            v-model="ruleForm.slideCategoryId"
            class="m-2 small_input"
            placeholder="请选择投放终端"
            size="large"
          >
            <el-option
              v-for="item in terminalList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属分类" prop="channelId">
          <el-select
            v-model="ruleForm.channelId"
            class="m-2 small_input"
            placeholder="请选择所属分类"
            size="large"
          >
            <el-option
              v-for="item in firstLevelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select> </el-form-item
      ></el-col>
    </el-row>
    <el-form-item label="跳转链接" prop="linkUrl">
      <el-input
        class="big_input"
        clearable
        v-model="ruleForm.linkUrl"
        placeholder="请输入跳转链接"
      />
    </el-form-item>
    <el-form-item label="焦点图" prop="imagePath">
      <ImgUpload
        v-if="childShow"
        :type="2"
        :limit="1"
        ref="addEditImgRef"
        :imagePath="ruleForm.imagePath"
        @change-image="changeImage"
      ></ImgUpload>
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
      :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import ImgUpload from "components/ImgUpload.vue";
import { getFirstLevel } from "network/articleClassification.js";
import {
  getSlideDetail,
  addSlide,
  editSlide,
} from "network/slideManagement.js";
import {
  toRefs,
  reactive,
  ref,
  unref,
  onMounted,
  toRaw,
  computed,
  watch,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { isHttp, textFilter, isEditorNull } from "common/utils";
import constGlobal from "common/global.js";
export default {
  name: "AddEditSlide",
  components: {
    ImgUpload,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
    categoryList: Array,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const addEditImgRef = ref();
    const data = reactive({
      loading: false,
      childShow: false, //避免编辑传递数据过慢，子组件拿不到
      ruleForm: {
        title: "",
        imagePath: "",
        linkUrl: "",
        slideCategoryId: null,
        channelId: null,
      },
      rules: {
        title: [
          { required: true, message: "请填写标题" },
          { min: 2, max: 50, message: "标题为2-50字" },
        ],
        slideCategoryId: [
          {
            required: true,
            message: "请选择投放终端",
          },
        ],
        channelId: [
          {
            required: true,
            message: "请选择所属分类",
          },
        ],
        linkUrl: [
          {
            required: true,
            message: "请填写跳转链接",
          },
        ],
        imagePath: [
          {
            required: true,
            message: "请上传焦点图",
          },
        ],
      },
      firstLevelList: [],
      terminalList: [
        {
          key: 0,
          value: "移动端",
        },
        {
          key: 1,
          value: "电脑端",
        },
      ], //终端
      submitDisabled:false
    });

    onMounted(() => {
      getLevelClass(); //获取全部一级分类  
      //编辑-获取详情
    if (props.editId > 0) {
      data.loading = true;
      getSlideDetail(props.editId).then((result) => {
        if (result && result.code == 1) {
          data.childShow = true;
          data.loading = false;
          data.ruleForm = result.result;
        } else {
          data.loading = false;
          ElMessage.error(result.message);
        }
      });
    } else {
      data.childShow = true;
    }
    });
    function getLevelClass() {
      getFirstLevel().then((res) => {
        if (res && res.code == 1) {
          data.firstLevelList = res.result;
        } else {
          ElMessage.error(res.message);
        }
      });
    }
  
    //获取图片上传组件传过来的
    const changeImage = (arr) => {
      if (arr && arr.length > 0) {
        data.ruleForm.imagePath = arr[0].url;
        ruleFormRef.value.clearValidate("imagePath");
      } else {
        data.ruleForm.imagePath = "";
      }
    };

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled=true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd() {
      if (data.ruleForm.linkUrl && !isHttp(data.ruleForm.linkUrl)) {
        ElMessage.warning("跳转链接必须使用http或https开头");
        return false;
      }
      data.loading = true;
      let result = "";
      if (props.editId > 0) {
        data.ruleForm.id = props.editId;
        result = await editSlide(data.ruleForm);
      } else {
        result = await addSlide(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(
          result.message,
          props.editId > 0 ? "编辑" : "添加",
          {
            confirmButtonText: "确定",
          }
        );
        if (addEditImgRef.value) {
            addEditImgRef.value.submitData(data.ruleForm.imagePath);
        }
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(
          result.message,
          props.editId > 0 ? "编辑" : "添加",
          {
            confirmButtonText: "确定",
            callback: (action) => {},
          }
        );
      }
    }
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
      // 关闭弹窗 判断图片删除
      if (addEditImgRef.value) {
        addEditImgRef.value.cancelData();
      }
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      addEditImgRef,
      changeImage,
      submitForm,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 450px;
}

>>> .el-form-item--large .el-form-item__content {
  line-height: 20px !important;
}
</style>

